import { createSlice } from '@reduxjs/toolkit';
import { QUESTION_BANKS } from '../../actions/QuestionBanks/actionTypes';

const initialState = {
  questionBanks: {
    isLoading: false,
    data: {
      questionBanks: [],
      assessmentCategories: [],
      questionBank: null
    },
    errors: '',
    message: ''
  }
};

export const questionBanksSlice = createSlice({
  name: QUESTION_BANKS,
  initialState,
  reducers: {
    getQuestionBanksAction: (state) => {
      state.questionBanks.isLoading = true;
      state.questionBanks.errors = '';
    },
    getQuestionBanksSuccessAction: (state, action) => {
      if (action.payload) {
        const p = action.payload;
        const raw =
          p.assessmentCategoryQuestions ?? p.AssessmentCategoryQuestions ?? [];
        const list = Array.isArray(raw) ? raw : [];
        // Stable row ids + explicit isActive so inactive (soft-deleted) rows show and the grid sorts reliably.
        state.questionBanks.data.questionBanks = list.map((q) => ({
          ...q,
          id: q.id ?? q.Id,
          isActive: q.isActive ?? q.IsActive,
        }));
        state.questionBanks.data.assessmentCategories =
          p.assessmentCategories ?? p.AssessmentCategories ?? [];
      }
      state.questionBanks.isLoading = false;
    },
    getQuestionBanksFailureAction: (state, action) => {
      state.questionBanks.isLoading = false;
      state.questionBanks.errors = action.payload;
    },
    deleteQuestionBankAction: (state) => {
      state.questionBanks.isLoading = true;
      state.questionBanks.errors = '';
    },
    deleteQuestionBankSuccessAction: (state, action) => {
      state.questionBanks.isLoading = false;
      const p = action.payload;
      if (Number(p?.data) === 1 && p?.status === 'Success') {
        state.questionBanks.message = 'Deleted Successfully!';
        state.questionBanks.errors = '';
      } else {
        state.questionBanks.message = '';
        state.questionBanks.errors =
          typeof p?.message === 'string' && p.message.trim()
            ? p.message
            : 'Cannot delete. Reference exists!';
      }
    },
    deleteQuestionBankFailureAction: (state, action) => {
      state.questionBanks.isLoading = false;
      state.questionBanks.errors = action.payload;
    },
    setQuestionBankAction: (state) => {
      state.questionBanks.isLoading = true;
      state.questionBanks.errors = '';
    },
    setQuestionBankSuccessAction: (state, action) => {
      state.questionBanks.isLoading = false;
      const p = action.payload;
      // FastAPI returns the question Id in ``data``; legacy .NET used ``1`` for success.
      const savedId = Number(p?.data);
      const ok = p?.status === 'Success' && Number.isFinite(savedId) && savedId > 0;
      if (ok) {
        state.questionBanks.message = 'Saved Successfully!';
        state.questionBanks.errors = '';
      } else {
        state.questionBanks.message = '';
        state.questionBanks.errors =
          typeof p?.message === 'string' && p.message.trim()
            ? p.message
            : 'Cannot save. Question already exists!';
      }
    },
    setQuestionBankFailureAction: (state, action) => {
      state.questionBanks.isLoading = false;
      state.questionBanks.errors = action.payload;
    },
    getQuestionBankAction: (state) => {
      state.questionBanks.isLoading = true;
      state.questionBanks.errors = '';
    },
    getQuestionBankSuccessAction: (state, action) => {
      if (action.payload) {
        state.questionBanks.data.questionBank = action.payload;
      }
      state.questionBanks.isLoading = false;
    },
    getQuestionBankFailureAction: (state, action) => {
      state.questionBanks.isLoading = false;
      state.questionBanks.errors = action.payload;
    },
    resetQuestionBankAction: (state) => {
      state.questionBanks.message = '';
      state.questionBanks.errors = '';
      state.questionBanks.data.questionBank = null;
    }
  }
});

export const {
  getQuestionBanksAction,
  getQuestionBanksSuccessAction,
  getQuestionBanksFailureAction,
  deleteQuestionBankAction,
  deleteQuestionBankFailureAction,
  deleteQuestionBankSuccessAction,
  setQuestionBankAction,
  setQuestionBankFailureAction,
  setQuestionBankSuccessAction,
  resetQuestionBankAction,
  getQuestionBankAction,
  getQuestionBankFailureAction,
  getQuestionBankSuccessAction
} = questionBanksSlice.actions;

export default questionBanksSlice.reducer;
